import { render, staticRenderFns } from "./auction-program-groups.vue?vue&type=template&id=7dd345f0&"
import script from "./auction-program-groups.vue?vue&type=script&lang=js&"
export * from "./auction-program-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports